import './Statistics.css'
import { Button, ButtonGroup, Col, InputGroup, InputGroupText, Nav, NavItem, NavLink, Row, TabContent, TabPane } from "reactstrap"
import { useGetStatisticsQuery } from "../../backoffice/apis/statisticsAPI";
import { useTranslation } from 'react-i18next';
import { PromotionCriteria } from '../../backoffice/dtos/promotions/promotionCriteria';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getUserReadableDateRange, rangeParse } from '../../helpers/Types';
import { faFileExcel, faFilter, faX } from '@fortawesome/free-solid-svg-icons';
import CriteriaModal from '../criteria/CriteriaModal';
import { useMemo, useState } from 'react';
import Statistics from './Statistics';
import { downloadStatisticsExcel } from '../../backoffice/apis/excelAPI';
import { StatisticsModel } from '../../backoffice/dtos/statistics/statisticsModel';
import { SelectOption } from '../../helpers/SelectOption';
import { StatisticsGroupModel } from '../../backoffice/dtos/statistics/statisticsGroupModel';
import Select from 'react-select';


export default function StatisticsBody(
    {
        initialFilter,
        setSelectedPromotionCriteria,
        promotionCriteria,
        toggle
    }: {
        initialFilter: PromotionCriteria,
        setSelectedPromotionCriteria: (criteria: PromotionCriteria) => void
        promotionCriteria: PromotionCriteria,
        toggle: () => void
    }
) {
    const { data: statisticsModel, isLoading: areStatisticsLoading } = useGetStatisticsQuery(promotionCriteria, { refetchOnMountOrArgChange: true })

    if (!statisticsModel)
        return <></>


    return <InnerStatisticsBody
        initialFilter={initialFilter}
        setSelectedPromotionCriteria={setSelectedPromotionCriteria}
        promotionCriteria={promotionCriteria}
        toggle={toggle}
        statisticsModel={statisticsModel}
    />
}

function InnerStatisticsBody(
    {
        initialFilter,
        setSelectedPromotionCriteria,
        promotionCriteria,
        toggle,
        statisticsModel
    }: {
        initialFilter: PromotionCriteria,
        setSelectedPromotionCriteria: (criteria: PromotionCriteria) => void
        promotionCriteria: PromotionCriteria,
        toggle: () => void,
        statisticsModel: StatisticsModel
    }
) {
    const { t } = useTranslation(['statistics', 'promotion_timeline', 'common'])
    const [criteriaToggle, setCriteriaToggle] = useState<boolean>(false);
    const [activeTab, setActiveTab] = useState('0');
    const [selection, setSelection] = useState<{value: StatisticsGroupModel | undefined; label: string }>(statisticsModel.statisticsGroupModels.length > 0 ? { value: statisticsModel.statisticsGroupModels[0], label: statisticsModel.statisticsGroupModels[0].description } : { value: undefined, label: "Unknown"} )
    const options: {value: StatisticsGroupModel | undefined; label: string }[] = useMemo(() => {
        return statisticsModel.statisticsGroupModels.map(m => ({value: m, label: m.description}))
    }, [statisticsModel.statisticsGroupModels])

    return (
        <>
            <Row className='m-3'>
                <Col className='d-flex flex-column justify-content-end'>
                    <strong>{t('statistics_title', { ns: 'promotion_timeline' })} {promotionCriteria.dateRange && getUserReadableDateRange(rangeParse(promotionCriteria.dateRange))}</strong>
                </Col>
                <Col sm="auto">
                    <ButtonGroup>
                        <Button onClick={() => setCriteriaToggle(rel => !rel)}><FontAwesomeIcon icon={faFilter} /></Button>
                        <Button color='success' onClick={async () => { await downloadStatisticsExcel(promotionCriteria) }}><FontAwesomeIcon icon={faFileExcel} /></Button>
                    </ButtonGroup>
                </Col>
                <Col sm={1} md={1} className='justify-content-end d-flex flex-row'>
                    <Button color='danger' onClick={toggle}><FontAwesomeIcon icon={faX} /></Button>
                </Col>
            </Row>
            <Row className='mb-4 mt-5'>
                <Col sm="5">
                    <InputGroup>
                        <InputGroupText>{t('Department', ["common"])}</InputGroupText>
                    <Select
                        isClearable={false}
                        className='react-select w-75'
                        classNamePrefix='select'
                        options={options}
                        value={selection}
                        onChange={(choice) => choice && setSelection({...choice})}
                        onBlur={_ => {}}
                        />
                    </InputGroup>
                </Col>
            </Row>
            <Nav tabs>
                {
                    selection.value && selection.value.statisticsProductTypeModels.map(
                        (it, i) => {
                            return (
                                <>
                                    <NavItem>
                                        <NavLink active={activeTab == `${i}`} onClick={() => { setActiveTab(`${i}`) }}>
                                            {
                                                it.description
                                            }
                                        </NavLink>
                                    </NavItem>
                                </>
                            )
                        }
                    )
                }
            </Nav>
            <TabContent activeTab={activeTab}>
                {
                    selection.value && selection.value.statisticsProductTypeModels.map(
                        (it, i) => {
                            return (
                                <>
                                    <TabPane tabId={`${i}`}>
                                        <Statistics statisticsModel={it} measurementType={selection.value!.measurementType} />
                                    </TabPane>
                                </>
                            )
                        }
                    )
                }
            </TabContent>
            <CriteriaModal
                setSelectedPromotionCriteria={setSelectedPromotionCriteria}
                toggle={() => setCriteriaToggle(rel => !rel)}
                initialFilter={initialFilter}
                isOpen={criteriaToggle}
                currentFilter={promotionCriteria}
            />
        </>
    )
}